import * as React from 'react';
import Chip from '@material-ui/core/Chip';
import { useTranslate, useRecordContext } from 'react-admin';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

import { Record } from 'ra-core';
interface Props {
    record?: Record;
    basePath?: string;
    label?: string;
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        accepted: {
            color: 'white',
            backgroundColor: 'green',
        },
        rejected: {
            color: 'white',
            backgroundColor: 'red',
        },
        pending: {
            color: 'black',
            backgroundColor: 'orange',
        },
    })
);
const CourseStatusField = props => {
    const translate = useTranslate();
    const record = useRecordContext();
    const classes = useStyles({});
    if (record) {
        const statut = props.source ? record[props.source] : record.statut;
        return statut ? (
            <Chip
                size="small"
                label={translate(`resources.reviews.status.${statut}`)}
                className={classes[statut]}
            />
        ) : null;
    } else return null;
};
export default CourseStatusField;
